import React, { useEffect, useState } from 'react';

import { sortOptions } from '@/constants/used-cars/used-cars.constants';
import { useVehicles } from '@/hooks/used-cars/vehicles.hook';
import { SortOption } from '@/types/used-cars/used-cars.types';

import { SearchResultSelect } from '../search-result-select/search-result-select';
import { SearchResultsActionWrapper } from '../search-results-action-wrapper/search-results-action-wrapper';

import { SortOptions } from './components/sort-options/sort-options';

export const SortSelect: React.FC<{
  onSortChange: (option: SortOption) => void;
  overlayClassName?: string;
  current?: string;
}> = ({ onSortChange, overlayClassName = '', current }) => {
  const { vehiclesMeta } = useVehicles();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(false);
  }, [vehiclesMeta.sort]);

  const currentLabel = sortOptions.find((option) => option.value === current);

  return (
    <SearchResultsActionWrapper label="Sort By">
      <SearchResultSelect
        content={
          <SortOptions
            setSorting={onSortChange}
            options={sortOptions}
            sorting={currentLabel || vehiclesMeta.sort}
          />
        }
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        overlayClassName={overlayClassName}
      >
        {null}
      </SearchResultSelect>
    </SearchResultsActionWrapper>
  );
};
